module.exports = __webpack_public_path__ + "img/purchase-logo.ae9c6b5b.svg";